export const DEFAULT_SMALL_SNOWFLAKE_COUNT = 250
export const DEFAULT_MEDIUM_SNOWFLAKE_COUNT = 50
export const DEFAULT_LARGE_SNOWFLAKE_COUNT = 50

export const SIZE_CLASS_MAP = {
  small: (index: number) => `snowflake _${index}` as const,
  medium: (index: number) => `snowflake _md _md-${index}` as const,
  large: (index: number) => `snowflake _lg _lg-${index}` as const,
}
